import InternationalizedInput from '@components/ui/internationalized-input/internationalized-input';
export default InternationalizedInput;
